<template>
	<!-- 问卷列表 -->
	<div class="bigcontent columnFlx">
		<div class="top columnFlx" style="margin-top: 2px">
			<div class="topfirst betweenFlx" style="margin-bottom: 0">
				<div class="topfirst">
					<div class="inpstyle">
						<p>问卷名称:</p>
						<el-input type="text" v-model="queryParams.questionnaireName" placeholder="单行输入"
							style="width: 185px"></el-input>
					</div>
					<div class="inpstyle">
						<p>发布状态:</p>
						<el-select v-model="queryParams.releaseStatus" placeholder="请选择" clearable
							ref="loanStatusSelect1" style="width: 185px">
							<el-option v-for="item in stateDic" :key="item.value" :label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
					</div>
					<div class="inpstyle">
						<p>类型:</p>
						<el-select v-model="queryParams.questionnaireType" placeholder="请选择" clearable
							ref="loanStatusSelect1" style="width: 185px">
							<el-option v-for="item in typeSelect" :key="item.value" :label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
					</div>
				</div>
				<div>
					<el-button @click="getListReset">重置</el-button>
					<el-button type="primary" @click="getDataOne">查询</el-button>
					<!-- <el-button type="success" @click="handleExport">导出</el-button> -->
				</div>
			</div>
		</div>
		<div class="content">
			<el-table :data="tableData" style="width: 100%" border :header-cell-style="{ background: '#F6F7FA' }"
				:cell-style="{ background: '#ffffff' }" :empty-text="loading ? '加载中' : '暂无数据'">
				<el-table-column prop="questionnaireName" label="问卷名称" align="left" width="400px"
					class-name="custom-questionnaire-column">
					<template slot-scope="scope">
						<span style="cursor: pointer; color: #1877ff" :class="
                scope.row.ifTop == 1 || scope.row.ifTop === '1' ? 'text' : ''
              " @click="handleShareClick(scope.row)">{{ scope.row.questionnaireName }}
						</span>
						<span class="ifTop" v-if="scope.row.ifTop == 1 || scope.row.ifTop === '1'">置顶</span>
					</template>
				</el-table-column>
				<el-table-column prop="questionnaireType" label="类型" align="center">
					<template slot-scope="scope">
						{{ scope.row.questionnaireType === '1' ? '问卷'
			        : scope.row.questionnaireType === '2' ? '考试'
			        : scope.row.questionnaireType === '3' ? '测评'
			        : '-' }}
					</template>
				</el-table-column>
				<el-table-column prop="releaseStatus" label="发布状态" align="center">
					<template slot-scope="scope">
						<span :class="[
		        scope.row.releaseStatus === 1
		          ? 'isReleaseTrue'
		          : 'isReleaseFalse',
		      ]">
							{{ scope.row.releaseStatus == 1 ? "已发布" : "未发布" }}
						</span>
					</template>
				</el-table-column>
				<el-table-column prop="questionNum" label="题目数量" align="center">
				</el-table-column>
				<el-table-column prop="browseNum" label="浏览数量" align="center">
				</el-table-column>
				<el-table-column prop="dataNum" label="收集数量" align="center">
				</el-table-column>
				<el-table-column prop="dataNum" label="参与人数" align="center">
				</el-table-column>
				<el-table-column prop="createTime" label="问卷创建时间" align="center">
				</el-table-column>
				<el-table-column label="操作" width="200" align="center">
					<template slot-scope="scope">
						<el-button @click.native.prevent="editClick(tableData[scope.$index])" type="text" size="small">
							重新编辑
						</el-button>
						<el-button v-if="scope.row.releaseStatus == 1"
							@click.native.prevent="handleShareClick(tableData[scope.$index])" type="text" size="small">
							分享转发
						</el-button>
						<el-button v-else @click.native.prevent="fbClick(tableData[scope.$index])" type="text"
							size="small">
							发布问卷
						</el-button>
						<el-dropdown v-if="scope.row.releaseStatus == 1" @command="handleCommand">
							<span class="el-dropdown-link">
								更多<i class="el-icon-arrow-down el-icon--right"></i>
							</span>
							<el-dropdown-menu slot="dropdown">
								<el-dropdown-item :command="
                    beforeHandleCommand(
                      scope.$index,
                      scope.row,
                      scope.row.ifTop == 1 || scope.row.ifTop === '1'
                        ? '取消置顶'
                        : '置顶'
                    )
                  ">
									{{
                    scope.row.ifTop == 1 || scope.row.ifTop === "1"
                      ? "取消置顶"
                      : "置顶"
                  }}
								</el-dropdown-item>
								<el-dropdown-item :command="
                    beforeHandleCommand(scope.$index, scope.row, '数据统计')
                  ">数据统计</el-dropdown-item>
								<el-dropdown-item :command="
                    beforeHandleCommand(scope.$index, scope.row, '创建副本')
                  ">创建副本</el-dropdown-item>
								<el-dropdown-item :command="
                    beforeHandleCommand(scope.$index, scope.row, '结束问卷')
                  ">结束问卷</el-dropdown-item>
								<el-dropdown-item :command="
                    beforeHandleCommand(scope.$index, scope.row, '删除问卷')
                  ">删除问卷</el-dropdown-item>
								<el-dropdown-item :command="
                    beforeHandleCommand(scope.$index, scope.row, '管理员设置')
                  ">管理员设置</el-dropdown-item>
								<el-dropdown-item :command="
				    beforeHandleCommand(scope.$index, scope.row, '红包设置')
				  ">红包设置</el-dropdown-item>
								<el-dropdown-item :command="
				    beforeHandleCommand(scope.$index, scope.row, '邮件分享')
				  ">邮件分享</el-dropdown-item>
				  <el-dropdown-item :command="
                    beforeHandleCommand(scope.$index, scope.row, '打印')
                  ">打印</el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown>
						<el-dropdown v-else @command="handleCommand">
							<span class="el-dropdown-link">
								更多<i class="el-icon-arrow-down el-icon--right"></i>
							</span>
							<el-dropdown-menu slot="dropdown">
								<el-dropdown-item :command="
                    beforeHandleCommand(
                      scope.$index,
                      scope.row,
                      scope.row.ifTop == 1 || scope.row.ifTop === '1'
                        ? '取消置顶'
                        : '置顶'
                    )
                  ">
									{{
                    scope.row.ifTop == 1 || scope.row.ifTop === "1"
                      ? "取消置顶"
                      : "置顶"
                  }}
								</el-dropdown-item>
								<el-dropdown-item :command="
                    beforeHandleCommand(scope.$index, scope.row, '数据统计')
                  ">数据统计</el-dropdown-item>
								<el-dropdown-item :command="
                    beforeHandleCommand(scope.$index, scope.row, '创建副本')
                  ">创建副本</el-dropdown-item>
								<el-dropdown-item :command="
                    beforeHandleCommand(scope.$index, scope.row, '删除问卷')
                  ">删除问卷</el-dropdown-item>
								<el-dropdown-item :command="
                    beforeHandleCommand(scope.$index, scope.row, '管理员设置')
                  ">管理员设置</el-dropdown-item>
				  <el-dropdown-item :command="
                    beforeHandleCommand(scope.$index, scope.row, '打印')
                  ">打印</el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown>
					</template>
				</el-table-column>
			</el-table>
			<div class="pagination">
				<el-pagination background layout="prev, pager, next" :page-size="queryParams.pageSize"
					:current-page="currentPage" :total="total" @current-change="handlePageChange">
				</el-pagination>
			</div>
		</div>
		<el-dialog title="分享" :visible.sync="dialogVisible" width="800px">
			<div style="display: flex; padding: 40px; background: #fff">
				<div class="left-panel" style="
            background-image: url('https://ai-public.mastergo.com/ai/img_res/c85e4dd3c85760773fb9d40f30d1914a.jpg');
            background-size: 100% 100%;
          ">
					<div class="card">
						<h2 class="card-title">{{ this.clickItem.questionnaireName }}</h2>
						<img :src="clickItem.qrCode" class="qr-code" />
					</div>
				</div>
				<!-- 右侧信息区 -->
				<div class="right-panel">
					<div class="info-box">
						<h2 class="info-title">问卷信息</h2>
						<p class="info-item">问卷名称: {{ clickItem.questionnaireName }}</p>
						<p class="info-item">
							问卷备注: {{ clickItem.questionnaireDescribe }}
						</p>
					</div>

					<div class="link-box">
						<h2 class="link-title">问卷链接</h2>
						<div style="
                width: 100%;
                border: solid 1px #efefef;
                padding: 4px;
                height: 40px;
              ">
							<input type="text" style="width: 100%; height: 40px" readonly :value="clickItem.qrCode" />
						</div>

						<div class="btn-group">
							<button class="btn" @click="copyClick">复制链接</button>
							<button class="btn" @click="downs">下载图片</button>
						</div>
					</div>
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="dialogVisible = false">确 定</el-button>
			</span>
		</el-dialog>
		<questionTemplate :showDialog="showDialog" :questionnaireType="questionnaireType" @close-dialog="showDialog = false" :params="{ id: lookId, type: 2 }"
			@update="getData"></questionTemplate>
		<div>
			<div class="coverShow" v-show="showCollaborator">
				<div class="container-gj" @click="showAnalysis = false">
					<div class="container-gd" @click.stop>
						<div class="header">
							<p>管理员设置</p>
							<i class="fa-solid fa-circle-xmark" style="color: #8290a3; cursor: pointer"
								@click="showCollaborator = false"></i>
						</div>
						<div style="
                font-size: 16px;
                font-weight: 500;
                color: #333333;
                width: 80%;
                text-align: center;
                margin-left: 10%;
                margin-bottom: 20px;
                margin-top: 20px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              ">
							{{ collaboratorName }}
						</div>
						<div style="padding: 0 80px">
							<img :src="collaboratorQrCode" alt="二维码" class="qr-code" />
						</div>
						<div style="
                font-size: 14px;
                font-weight: 400;
                color: #7b818a;
                width: 80%;
                text-align: center;
                margin-left: 10%;
                margin-top: 20px;
              ">
							请扫码进入小程序邀请管理员
						</div>
						<button class="download-btn" @click="downloadQrCode">
							下载问卷二维码
						</button>
					</div>
				</div>
			</div>
		</div>

		<el-dialog :title="redTitle" :visible.sync="RedEnvelopeDialogVisible" width="800px"
			:before-close="handleDialogClose">
			<div class="dialogClose" @click="handleDialogClose"></div>
			<div class="redList" :class="{ noData: !redListData.length }" v-infinite-scroll="redLoadMore"
				:infinite-scroll-disabled="redListDisabled" infinite-scroll-immediate="false"
				infinite-scroll-distance="20" v-if="redListShow">
				<div v-for="(item, index) in redListData" :key="index" class="item">
					<div class="title">
						<img src="https://ossfastmake.mustke.com/qrCode/tupian/1766556738098.svg" />
						{{ item.questionnaireName }}
					</div>
					<div class="collection">
						已领取金额：{{ item.receivedAmount }}/{{ item.totalAmount }}元
						<span @click="redCheckClaim(item)">查看领取情况</span>
					</div>
					<div class="name">红包发送人昵称：{{ item.senderName }}</div>
					<div class="probability">中奖概率：{{ item.probability }}%</div>
					<div class="condition">抽奖条件：{{ item.lotteryConditions }}</div>
					<div class="addTime">创建时间：{{ formatTime(item.createTime) }}</div>
				</div>
				<p v-if="redList.loading" class="loading">加载中...</p>
				<p v-if="!redList.loading && !redListData.length" class="noMore">暂无数据</p>
				<div :class="['button', redListData.length === 0 && 'special']" @click="redAddRedEnvelope">
					{{ redListData.length === 0 ? '设置红包' : '继续添加红包' }}
				</div>
			</div>
			<div class="redSettings" v-if="redSettingsShow">
				<div class="heading">金额设置</div>
				<div class="content">
					<div class="item">
						<div class="box">
							<div class="label">红包抽中概率</div>
							<div class="region">
								<input type="number" v-model="redSettings.probability"
									@input="handleNumberInput('probability')"
									@blur="handleNumberBlur('probability', 1, 100)" maxlength="3" placeholder="1-100" />
								<span class="unit">%</span>
							</div>
						</div>
						<div class="box">
							<div class="label">红包发送人昵称</div>
							<div class="region">
								<input type="text" v-model="redSettings.name" placeholder="请输入发送人昵称" />
							</div>
						</div>
					</div>
					<div class="item">
						<div class="box">
							<div class="label">红包类型</div>
							<div class="region">
								<div class="option" :class="{ active: redSettings.type === 1 }"
									@click="redSettings.type = 1">固定金额红包
								</div>
								<div class="option" :class="{ active: redSettings.type === 2 }"
									@click="redSettings.type = 2">拼手气红包
								</div>
							</div>
						</div>
						<div class="box"></div>
					</div>
					<div class="item">
						<!-- 固定金额红包 -->
						<div class="box" v-if="redSettings.type === 1">
							<div class="label">单个金额</div>
							<div class="region">
								<input type="digit" v-model="redSettings.singleAmount"
									@input="handleNumberInput('singleAmount')"
									@blur="handleNumberBlur('singleAmount', 0.1, 200)" placeholder="请输入单个金额" />
							</div>
						</div>
						<!-- 拼手气红包 -->
						<div class="box" v-if="redSettings.type === 2">
							<div class="label">总金额</div>
							<div class="region">
								<input type="digit" v-model="redSettings.totalAmount"
									@input="handleNumberInput('totalAmount')"
									@blur="handleNumberBlur('totalAmount', 0.1, 1000000)" placeholder="请输入总金额" />
							</div>
						</div>
						<div class="box">
							<div class="label">红包个数</div>
							<div class="region">
								<input type="number" v-model="redSettings.redEnvelopesNumber"
									@input="handleNumberInput('redEnvelopesNumber')"
									@blur="handleNumberBlur('redEnvelopesNumber', 1, 1000)" placeholder="请输入红包个数" />
							</div>
						</div>
					</div>
					<div class="item">
						<div class="box" v-if="redSettings.type === 2">
							<div class="label">单个红包金额</div>
							<div class="region">
								<input type="digit" v-model="redSettings.minimumAmount"
									@input="handleNumberInput('minimumAmount')"
									@blur="handleNumberBlur('minimumAmount', 0.1, 199)" placeholder="0.1" />
								<span class="segmentation">至</span>
								<input type="digit" v-model="redSettings.maximumAmount"
									@input="handleNumberInput('maximumAmount')"
									@blur="handleNumberBlur('maximumAmount', 0.1, 200)" placeholder="200" />
							</div>
						</div>
					</div>
				</div>
				<div class="heading">抽奖条件</div>
				<div class="content">
					<div class="item">
						<div :class="['label switch', { checked: redSettings.once }]"
							@click="redSettings.once = !redSettings.once">
							每个账号仅允许抽取一次</div>
						<div class="region"></div>
					</div>
					<div class="item">
						<div class="box">
							<div :class="['label switch', { checked: redSettings.timeMin }]" @click="toggleTimeMin">
								答题时长不小于
							</div>
							<div class="region">
								<input type="number" v-model="redSettings.fractionMaxNumber"
									@input="handleNumberInput('fractionMaxNumber')"
									@blur="handleNumberBlur('fractionMaxNumber', 1, 100)" placeholder="1-100"
									:disabled="!redSettings.timeMin" />
								<el-select v-model="timeType" ref="loanStatusSelect1">
									<el-option v-for="item in timeColumns" :key="item.value" :label="item.label"
										:value="item.value">
									</el-option>
								</el-select>
							</div>
						</div>
						<div class="box"></div>
					</div>
					<div class="item" v-if="questionnaireType === '2'">
						<div class="box">
							<div :class="['label switch', { checked: redSettings.fractionMin }]"
								@click="toggleFractionMin">
								分数不低于</div>
							<div class="region">
								<input type="number" v-model="redSettings.fractionMinNumber"
									@input="handleNumberInput('fractionMinNumber')"
									@blur="handleNumberBlur('fractionMinNumber', 1, 100)" placeholder="1-100"
									:disabled="!redSettings.fractionMin" />
								<span class="unit">分</span>
							</div>
						</div>
					</div>
				</div>
				<div class="kindReminder">
					<div class="title">
						温馨提示
						<img src="https://ossfastmake.mustke.com/wenjuan/tupian/提示-1770702453970.svg" mode="" />
					</div>
					<div class="text">
						1.若金额未被领取完，根据问卷结束时间或手动结束问卷，点击个人中心&#8594剩余额度，申请退回剩余金额。<br />
						2.如有其他疑问<span @click="onContact">联系客服</span>。<br />
						<div>3.为确保公平与真实，领取情况、中奖概率等信息将被公开。</div>
						4.根据总金额将收取1%的手续费。<br />
					</div>
				</div>
				<div class="settlement" :class="{ active: redSettings.type === 2 }">
					<div class="totalAmount">
						总金额：<span class="number">{{ Price }}</span>元
						<span class="remark">(红包总金额+手续费)</span>
					</div>
					<div class="button"
						:class="{ disabled: redSettings.probability === '' || redSettings.name === '' || Price <= 0 }"
						@click="redSettings.probability !== '' && redSettings.name !== '' && Price > 0 && redPaymentSubmit()">
						确认支付
					</div>
				</div>
			</div>
			<div class="redClaim" :class="{ noData: !redClaimData.length }" v-infinite-scroll="redClaimLoadMore"
				:infinite-scroll-disabled="redClaimDisabled" infinite-scroll-immediate="false" v-show="redClaimShow">
				<div class="text">
					已领取{{ redClaimDetail.claimedCount }}/{{ redClaimDetail.claimableCount }}个，
					共{{ redClaimDetail.claimedAmount }}/{{ redClaimDetail.totalAmount }}元
				</div>
				<div v-for="(item, index) in redClaimData" :key="index" class="item">
					<div class="west">
						<img :src="item.receiverAvatar" mode="" />
						<div class="region">
							<div class="name">{{ item.receiverName }}</div>
							<div class="time">{{ formatTime(item.grabTime) }}</div>
						</div>
					</div>
					<div class="east">{{ item.amount }}元</div>
				</div>
				<p v-if="redClaim.loading" class="loading">加载中...</p>
				<p v-if="!redClaim.loading && !redClaimData.length" class="noMore">暂无数据</p>
			</div>
		</el-dialog>

		<el-dialog :title="emailTitle" :visible.sync="EamilDialogVisible" width="800px"
			:before-close="handleDialogClose">
			<div class="dialogClose" @click="handleDialogClose"></div>
			<div class="emailList" :class="{ noData: !emailListData.length }" v-infinite-scroll="emailLoadMore"
				:infinite-scroll-disabled="emailListDisabled" infinite-scroll-immediate="false"
				infinite-scroll-distance="20" v-if="emailListShow">
				<div v-for="(item, index) in emailListData" :key="index" class="item">
					<div class="strip">邮件主题：<span>{{ item.subject }}</span></div>
					<div class="strip">发送时间：<span>{{ item.createTime }}</span></div>
					<div class="strip">人数：<span>{{ item.remark }}</span><span class="details"
							@click="emailOnDetails(item)">详情</span></div>
					<div class="strip">发送状态：<span>{{ item.sendStatus === 1 ? '发送成功' : '等待发送' }}</span></div>
				</div>
				<p v-if="emailList.loading" class="loading">加载中...</p>
				<p v-if="!emailList.loading && !emailListData.length" class="noMore">暂无数据</p>
				<div :class="['button', emailListData.length === 0 && 'special']" @click="emailAddRedEnvelope">发送新邮件
				</div>
			</div>
			<div class="emaiSettings" v-if="emailSettingsShow">
				<div class="heading">发件人信息</div>
				<div class="content">
					<div class="item">
						<div class="box">
							<div class="label">发件人昵称</div>
							<div class="region">
								<input type="text" v-model="emailSettings.name" placeholder="请输入发送人昵称" />
							</div>
						</div>
						<div class="box">
							<div class="label">发件人邮箱</div>
							<div class="region disabled">
								<input type="text" disabled v-model="emailSettings.email" placeholder="请输入发送人邮箱" />
							</div>
						</div>
					</div>
				</div>
				<div class="heading">邮件内容</div>
				<div class="content">
					<div class="item">
						<div class="box">
							<div class="label">邮件主题</div>
							<div class="region">
								<input type="text" v-model="emailSettings.theme" placeholder="请填问卷,谢谢!" />
							</div>
						</div>
					</div>
				</div>
				<div class="content special">
					<div class="item">
						<div class="label">邮件内容</div>
						<div class="region special">
							<textarea v-model="emailSettings.content" placeholder="请填写邮件内容" maxlength="500"
								@input="emailOnTextareaInput" />

							<div class="image-list">
								<div v-for="(item,index) in emailImageList" :key="index">
									<img class="block-image" :src="item" mode="" />
								</div>
								<div class="block" v-if="emailImageList.length < 3" @click="emailHandleSelect">
									<div class="icon"></div>
									<div class="text">上传图片</div>
								</div>
							</div>
							<div class="bottom">
								<div class="insert" @click="onInsert(true)">插入问卷链接</div>
								<div class="character">{{ emailTextNumber }}/500</div>
							</div>
						</div>
					</div>
				</div>
				<div class="heading">收件人邮箱</div>
				<div class="content special">
					<div class="item">
						<div class="region special end">
							<textarea class="textarea" placeholder="请输入,每一行一个邮箱地址;例如:问小卷，2344444444@qq.com"
								v-model="emailSettings.list" maxlength="-1" @input="emailHandleUpdate" />
							<div class="import" @click.stop="emailOnExcel">
								<img src="https://ossfastmake.mustke.com/qrCode/tupian/1766729577644.svg" mode="" />
								从Excel添加
							</div>
						</div>
					</div>
				</div>
				<div class="settlement">
					<div class="information">
						<div class="text">将发送给
							<span>{{ emailConsumption }}</span>收件人，将消费
							<span>{{ emailConsumption }}</span>邮件余额，余额：
							<span>{{ emailBalance }}</span>
						</div>
						<div class="recharge" @click="emailRecharge">充值</div>
					</div>
				</div>
				<div class="kindReminder">
					<div class="east">
						<div class="title">
							温馨提示
							<img src="https://ossfastmake.mustke.com/wenjuan/tupian/提示-1770702453970.svg" mode="" />
						</div>
						<div class="text">若购买大量邮件可 <span @click="onContact">联系客服</span> 领取优惠</div>
					</div>
					<div class="west">
						<div :class="['button', {disabled : emailIsSubmitting}]" @click="emailPaymentSubmit">发送邮件</div>
						<div :class="['policy', { checked : emailSettings.agree }]"
							@click="emailSettings.agree = !emailSettings.agree">
							我接受{{ emailSettings.appName }}反垃圾邮件政策
						</div>
					</div>
				</div>
			</div>
			<div class="emailRecord" :class="{ noData: !emailRecordData.length }"
				v-infinite-scroll="emailRecordLoadMore" :infinite-scroll-disabled="emailRecordDisabled"
				infinite-scroll-immediate="false" v-show="emailRecordShow">
				<div class="table-header" v-if="emailRecordData.length > 0">
					<div class="col col-email">邮箱号</div>
					<div class="col col-name">姓名</div>
					<div class="col col-status">发送情况</div>
					<div class="col col-action">操作</div>
				</div>
				<div class="table-body">
					<div v-for="(item, index) in emailRecordData" :key="index" class="table-row">
						<div class="col col-email">{{ item.recipientEmail }}</div>
						<div class="col col-name">{{ item.recipient }}</div>
						<div class="col col-status">
							<span :class="item.isSuccess === 1 ? 'success' : 'fail'">
								{{ item.isSuccess === 1 ? '成功' : '失败' }}
							</span>
						</div>
						<div class="col col-action">
							<div class="resend" @click="resendEmail(item)">再次发送</div>
						</div>
					</div>
				</div>
				<p v-if="emailRecord.loading" class="loading">加载中...</p>
				<p v-if="!emailRecord.loading && !emailRecordData.length" class="noMore">暂无数据</p>
			</div>
		</el-dialog>

		<div class="emailPrompt" v-if="emailPromptShow">
			<div class="content">
				<div class="title">温馨提示<div class="dialogClose" @click="emailPromptShow = false"></div>
				</div>
				<div class="policyPopup flexs" v-if="emailSettings.scene === 'policy'">
					<div class="text">请阅读并同意<span @click="emailPolicyShow = true">《问卷加加反垃圾邮件政策》</span>后发送邮件。</div>
				</div>
				<div class="balancePopup flexs" v-if="emailSettings.scene === 'balance'">
					<div class="text">余额不足，请充值后发送</div>
				</div>
				<div class="button">
					<div class="item" @click="emailPromptShow = false">取消</div>
					<div class="item" @click="emailSettings.scene === 'policy' ? 
						(emailSettings.agree = true,emailPromptShow = false) : 
						emailRecharge()">
						{{ emailSettings.scene === 'policy' ? '已阅读并同意' : '去充值' }}
					</div>
				</div>
			</div>
		</div>

		<div class="emailPolicy" v-if="emailPolicyShow">
			<div class="content">
				<div class="title">反垃圾邮件政策<div class="dialogClose" @click="emailPolicyShow = false"></div>
				</div>
				<div class="text">
					问卷加加坚决反对和抵制任何垃圾邮件，任何人不得利用问卷网发送任何未经请求的大量邮件或商业电子邮件(垃圾邮件)，所有邮件中都需包含有效的问卷网问卷链接。若违反本政策，我们有权停止邮件服务，暂停或终止您的帐户使用权。所有发送请求都需经过问卷网审核，所有通过问卷网发送的邮件，都将包含一个「举报垃圾邮件」的链接。如果您邮件的的回应率偏低，而滥用率或跳出率偏高，问卷网将依自行判断，随时停止为忽提供邮件服务。如果您的邮件受到举报，我们可能要求您提供邮件发送地址及其他相关信息，以便调查解决可题。如果您的邮件涉及任何虚假或违法违规内容，我们将把相关证据提交给公安机关。<br />
					我们可能会随时变更此政策，您应随时了解最新政策并遵守此政策。<br /><br />违法本政策的行为包含但不限于下列情况:<br /><br />·收件人事先没有提出要求或者同意接收的;<br />·标题或内容包含商业性、营销性信息;<br />·标题或内容包含欺骗、误导或虚假的信息;<br />·标题或内容包含欺诈或非法内容的链接地址;<br />·使用非法获取的邮箱地址、无效的邮箱地址;<br />·在没有获得问卷网许可下，擅自使用问卷网名义;<br />·违反了国家政策法律规定和问卷网服务条款。<br /><br />
					若您怀疑有人使用问卷网发送垃圾邮件，可发邮件至youzhi@qq.com 举报，我们会立即处理。
				</div>
			</div>
		</div>

		<div class="emailUpload" v-if="emailUploadShow">
			<div class="content">
				<div class="title">邮件分享<div class="dialogClose" @click="emailUploadShow = false"></div>
				</div>
				<div class="region">
					<div class="upload" @click.stop="emailUploadExcel">
						<img src="https://ossfastmake.mustke.com/wenjuan/tupian/上传-1766971756850.svg" mode="" />
						<div>点击上传</div>
					</div>
					<div class="text">请确保表头为"收件人","邮箱地址"字样 </div>
					<div class="contact" @click.stop="emailDownloadTemplate">下载模板</div>
				</div>
			</div>
		</div>

		<div class="Recharge" v-if="Recharge">
			<div class="content">
				<div class="title">{{ rechargeTitle }}
					<div class="dialogClose" @click="Recharge = false"></div>
				</div>
				<div class="tab">
					<div class="item" v-for="(item, index) in tabList" :key="item.id"
						:class="{ active: index === activeIndex }" @click.stop="onSelect(item, index)">
						<div class="number">{{ item.frequency }}封</div>
						<div class="money">￥{{ item.currentPrice }}</div>
						<div class="originalPrice">原价{{ item.originalPrice }}</div>
						<div class="text">{{ item.discountText }}</div>
					</div>
				</div>
				<div class="button" @click.stop="buyNow">立即购买</div>
			</div>
		</div>

		<div class="Payment" v-if="PaymentShow">
			<div class="content">
				<div class="title">支付<div class="dialogClose" @click="PaymentShow = false,clearPayTimer(),isSubmitting = false"></div>
				</div>
				<div class="region">
					<div class="item">应付金额：<span>￥{{ Price }}</span></div>
					<div class="item">订单编号：{{ PaymentData.outTradeNo }}</div>
					<div class="item">有效期：{{ getCurrentTime }} 至无限有效期</div>
				</div>
				<div class="code">
					<img class="brand" src="@/assets/images/123123.jpg" alt="" />
					<img class="image" :src="PaymentData.qrCodeBase64" alt="">
					<span>用微信扫一扫即可付款</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		userList,
		usercloseQuestionnaire,
		closeQuestionnaire,
		copyQuestionnaire,
		removeQuestionnaire,
		setQuestionnaireTop,
		getManageQrcode,
		getListByUuid,
		postRedPacketCreate,
		postRedPacketCalcAmount,
		getPayment,
		getClaimDetail,
		getEmailTaskList,
		getProductEmail,
		postEmailBuy,
		getUrlLink,
		postEmailCreateQuestionnaireEmailTask,
		getRemainingBalance,
		getTaskDetailList,
		postRetrySend
	} from "@/api/index.js";
	import questionTemplate from "@/components/QuestionTemplate/index.vue";

	export default {
		components: {
			questionTemplate,
		},
		dicts: ["sys_job_status"],
		data() {
			return {
				dialogVisible: false,
				tableData: [],
				clickItem: {},
				// 查询参数
				queryParams: {
					pageNum: 1,
					pageSize: 10,
					userKey: "",
					questionnaireName: "",
					releaseStatus: "",
					questionnaireType: ""
				},
				dateRange: [],
				form: {
					id: "",
					dealInfo: "",
				},
				total: 0,
				currentPage: 1,
				isAddShow: false,
				islookShow: false,
				input: "",
				dataOne: "",
				peopleID: "",
				stateDic: [{
						label: "所有",
						value: "",
					},
					{
						label: "已发布",
						value: "1",
					},
					{
						label: "未发布",
						value: "2",
					},
				],
				showDialog: false,
				lookId: "",
				showCollaborator: false,
				collaboratorQrCode: "",
				collaboratorName: "",
				loading: false,
				typeSelect: [{
						label: "所有",
						value: "",
					},
					{
						label: "问卷",
						value: "1",
					},
					{
						label: "考试",
						value: "2",
					},
					{
						label: "测评",
						value: "3",
					},
				],
				RedEnvelopeDialogVisible: false,
				redTitle: '红包设置',
				redListData: [],
				redList: {
					loading: false,
					pageNum: 1,
					pageSize: 10,
					currentUuid: '',
					hasMore: true
				},
				redListShow: false,
				redSettingsShow: false,
				redSettings: {
					probability: '', // 红包抽中概率
					name: '', // 红包发送人昵称
					type: 1, // 红包类型
					singleAmount: '', // 固定金额单个金额
					totalAmount: '', // 总金额
					minimumAmount: '', // 单个红包金额范围最小
					maximumAmount: '', // 单个红包金额范围最大
					redEnvelopesNumber: '', // 红包个数
					// 抽奖条件
					once: true, // 每个账号仅允许抽取一次
					timeMin: false, // 答题时长不小于
					fractionMaxNumber: '', // 答题时长不小于数
					fractionMin: false, // 分数不低于
					fractionMinNumber: '' // 分数不低于
				},
				questionnaireType: '',
				ActivityUuid: '',
				timePickerShow: false,
				timeType: '1',
				timeColumns: [{
						label: '秒',
						id: 1,
						value: '1'
					},
					{
						label: '分',
						id: 2,
						value: '2'
					},
					{
						label: '时',
						id: 3,
						value: '3'
					}
				],
				Price: 0,
				priceTimer: null,
				calculating: false,
				PaymentShow: false,
				PaymentData: {},
				redClaim: {
					loading: false,
					pageNum: 1,
					pageSize: 10,
					currentUuid: '',
					hasMore: true
				},
				redClaimShow: false,
				redClaimData: [],
				redClaimDetail: {},
				emailTitle: '邮件分享',
				EamilDialogVisible: false,
				emailListShow: false,
				emailListData: [],
				emailList: {
					loading: false,
					pageNum: 1,
					pageSize: 10,
					currentUuid: '',
					hasMore: true
				},
				emailSettingsShow: false,
				emailSettings: {
					name: '',
					email: 'wenjuan@mail.wjguanjia.com',
					theme: '',
					content: '',
					list: '',
					agree: false,
					appName: '问卷加加',
					scene: ''
				},
				emailImageList: [],
				emailTextNumber: 0,
				emailConsumption: 0,
				emailBalance: 0,
				emailIsSubmitting: false,
				emailUploadShow: false,
				emailReg: /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/,
				Recharge: false,
				rechargeTitle: '购买邮件',
				tabList: [],
				activeIndex: 0,
				getCurrentTime: '',
				emailPromptShow: false,
				emailPolicyShow: false,
				generateUrls: '',
				emailRecordData: [],
				emailRecordShow: false,
				emailRecord: {
					loading: false,
					pageNum: 1,
					pageSize: 15,
					currentUuid: '',
					hasMore: true
				},
				isSubmitting: false
			};
		},
		created() {
			window.addEventListener("keyup", this.enterSearchOrder);
		},
		computed: {
			redListDisabled() {
				return this.redList.loading || !this.redList.hasMore
			},
			redClaimDisabled() {
				return this.redClaim.loading || !this.redClaim.hasMore
			},
			emailListDisabled() {
				return this.emailList.loading || !this.emailList.hasMore
			},
			emailRecordDisabled() {
				return this.emailRecord.loading || !this.emailRecord.hasMore
			}
		},
		mounted() {
			this.queryParams.userKey = this.$route.query.peopleID;
			console.log(this.peopleID, "this.peopleID");
			this.getData();
			this.getRemainingBalanceData();
		},
		watch: {
			redSettings: {
				deep: true,
				handler() {
					clearTimeout(this.priceTimer)

					this.priceTimer = setTimeout(() => {
						this.redCalcPrice()
					}, 300)
				}
			}
		},
		methods: {
			beforeHandleCommand(index, row, command) {
				return {
					index: index,
					row: row,
					command: command,
				};
			},
			handleCommand(command) {
				console.log("dhwvqwvfw12312312312312312", command);
				switch (command.command) {
					case "数据统计":
						this.$router.push({
							path: "/DataStatisticsPage/DataDetail",
							query: {
								uuid: command.row.uuid,
							},
						});
						break;
					case "重新编辑":
						this.$router.push({
							path: "/create",
							query: {
								id: command.row.uuid,
							},
						});
						break;
					case "创建副本":
						this.copyMethod(command.index, command.row);
						break;
					case "结束问卷":
						this.endMethod(command.index, command.row);
						break;
					case "删除问卷":
						this.deleteMethod(command.index, command.row);
						break;
					case "管理员设置":
						getManageQrcode({
							questionnaireUuid: command.row.uuid,
						}).then((res) => {
							console.log(res.data.base64, "res000000000000");
							if (res.code === 200) {
								this.collaboratorQrCode = res.data.base64;
								this.collaboratorName = command.row.questionnaireName;
								this.showCollaborator = true;
							} else {
								this.$message.closeAll();
								this.$message({
									message: res.msg,
									type: "failed",
								});
							}
						});
						break;
					case "置顶":
					case "取消置顶":
						this.toggleTop(command.index, command.row);
						break;
					case "红包设置":
						this.openRedEnvelopeDialog(command.row)
						this.redTitle = '红包设置'
						this.redListShow = true
						this.questionnaireType = command.row.questionnaireType
						this.ActivityUuid = command.row.uuid
						break
					case "邮件分享":
						this.openEamilDialog(command.row)
						this.emailTitle = '邮件分享'
						this.emailListShow = true
						this.ActivityUuid = command.row.uuid
						this.emailSettings.content = `您好，《${command.row.questionnaireName}》，需要您填写，填写地址：，点击进入参与问卷。`
						break
					case "打印":
						this.printMethod(command.index, command.row);
						break;
				}
			},
			printMethod(index, row) {
				console.log(index, row, "打印");
				this.$router.push({
					path: "/printPreview",
					query: {
						id: row.uuid,
						type: row.questionnaireType
					},
				});
			},
			// 打开红包弹窗
			openRedEnvelopeDialog(row) {
				this.redListShow = false
				this.redSettingsShow = false
				this.redClaimShow = false
				this.RedEnvelopeDialogVisible = true
				this.redList.currentUuid = row.uuid
				this.redList.pageNum = 1
				this.redListData = []
				this.redListGetList()
			},
			handleDialogClose() {
				this.clearPayTimer()
				this.RedEnvelopeDialogVisible = false
				this.redListShow = false
				this.redSettingsShow = false
				this.redClaimShow = false
				this.redListData = []
				this.redList.pageNum = 1
				this.redList.hasMore = true
				this.questionnaireType = ''
				this.redSettings.probability = ''
				this.redSettings.name = ''
				this.redSettings.singleAmount = ''
				this.redSettings.totalAmount = ''
				this.redSettings.redEnvelopesNumber = ''
				this.redSettings.minimumAmount = ''
				this.redSettings.maximumAmount = ''
				this.redSettings.fractionMaxNumber = ''
				this.redSettings.fractionMinNumber = ''
				this.PaymentShow = false
				this.EamilDialogVisible = false
				this.emailListShow = false
				this.emailSettingsShow = false
				this.Recharge = false
				this.emailUploadShow = false
				this.Price = ''
				this.emailListData = []
				this.emailList.pageNum = 1
				this.emailList.hasMore = true
				this.emailList.loading = false
				this.emailRecordData = []
				this.emailRecordShow = false
				this.emailRecord.pageNum = 1
				this.emailRecord.hasMore = true

			},
			// 请求数据
			redListGetList() {
				if (this.redList.loading || !this.redList.hasMore) return
				this.redList.loading = true
				getListByUuid({
					uuid: this.redList.currentUuid,
					pageNum: this.redList.pageNum,
					pageSize: this.redList.pageSize
				}).then(res => {
					const list = res.rows || []

					if (list.length < this.redList.pageSize) {
						this.redList.hasMore = false
					}

					this.redListData.push(...list)
					this.redList.pageNum++
				}).finally(() => {
					this.redList.loading = false
				})
			},
			// 滚动触底触发
			redLoadMore() {
				if (this.redList.loading) return
				this.redListGetList()
			},
			redCheckClaim(e) {
				this.redClaimData = []
				this.redClaimDetail = {}
				this.redListShow = false
				this.redClaimShow = true
				this.redTitle = '查看领取详情'
				this.redClaim.currentUuid = e.packetUuid
				this.redClaim.loading = false
				this.redClaim.hasMore = true
				this.redClaimGetList()
			},
			redAddRedEnvelope() {
				this.redListShow = false
				this.redSettingsShow = true
			},
			formatTime(time) {
				if (!time) return ''
				const date = new Date(time)
				const Y = date.getFullYear()
				const M = String(date.getMonth() + 1).padStart(2, '0')
				const D = String(date.getDate()).padStart(2, '0')
				const h = String(date.getHours()).padStart(2, '0')
				const m = String(date.getMinutes()).padStart(2, '0')
				return `${Y}-${M}-${D} ${h}:${m}`
			},
			handleNumberBlur(key, min = 0.01, max = 200) {
				if (this.redSettings[key] === '' || this.redSettings[key] === null) return
				let val = Number(this.redSettings[key])
				if (isNaN(val)) {
					this.redSettings[key] = ''
					return
				}
				val = Math.min(max, Math.max(min, val))
				this.redSettings[key] = val
			},
			handleNumberInput(key) {
				let val = this.redSettings[key] + ''
				val = val.replace(/[^\d.]/g, '')
				val = val.replace(/\.{2,}/g, '.')
				if (val.indexOf('.') !== val.lastIndexOf('.')) {
					val = val.slice(0, val.lastIndexOf('.'))
				}
				if (val.indexOf('.') === -1 && val.length > 1) {
					val = val.replace(/^0+/, '0')
				}
				val = val.replace(/^(\d+)\.(\d{0,2}).*$/, '$1.$2')
				this.redSettings[key] = val
			},
			toggleTimeMin() {
				this.redSettings.timeMin = !this.redSettings.timeMin
			},
			toggleFractionMin() {
				this.redSettings.fractionMin = !this.redSettings.fractionMin
			},
			onContact() {

			},
			redCalcPrice() {
				// console.log('计算金额', this.ActivityUuid)
				if (this.calculating) {
					return Promise.resolve(this.Price)
				}
				this.calculating = true
				return postRedPacketCalcAmount({
						activityUuid: this.ActivityUuid,
						probability: this.redSettings.probability,
						senderName: this.redSettings.name,
						packetType: this.redSettings.type,
						totalAmount: this.redSettings.totalAmount,
						singleAmount: this.redSettings.singleAmount,
						packetCount: this.redSettings.redEnvelopesNumber,
						minAmount: this.redSettings.minimumAmount,
						maxAmount: this.redSettings.maximumAmount,
						isRepeatable: this.redSettings.once ? 0 : 1,
						minDuration: this.redSettings.timeMin ? this.redSettings.fractionMaxNumber : '',
						minScore: this.redSettings.fractionMin ? this.redSettings.fractionMinNumber : ''
					})
					.then(res => {
						console.log('res', res)
						this.Price = res.data || 0
						return this.Price
					})
					.finally(() => {
						this.calculating = false
					})
			},
			async redPaymentSubmit() {
				if (this.isSubmitting) {
				    return;
				}
				  
				this.isSubmitting = true;
				if (
					this.redSettings.type === 2 &&
					(this.redSettings.minimumAmount === '' || this.redSettings.maximumAmount === '')
				) {
					this.$message.warning(
						this.redSettings.minimumAmount === '' ?
						'请您设置单个最小金额' :
						'请您设置单个最大金额'
					)
					this.isSubmitting = false;
					return
				}
				if(this.redSettings.timeMin && this.redSettings.fractionMaxNumber <= 0) {
					this.$message.warning('请您输入答题时长')
					this.isSubmitting = false;
					return
				}
				const finalPrice = await this.redCalcPrice()
				if (!finalPrice || finalPrice <= 0) {
					this.$message.warning('金额计算中，请稍后')
					this.isSubmitting = false;
					return
				}
				try {
					const res = await postRedPacketCreate({
						activityUuid: this.ActivityUuid,
						probability: this.redSettings.probability,
						senderName: this.redSettings.name,
						packetType: this.redSettings.type,
						totalAmount: this.redSettings.type === 1 ? '' : this.redSettings.totalAmount,
						singleAmount: this.redSettings.type === 1 ? this.redSettings.singleAmount : '',
						packetCount: this.redSettings.redEnvelopesNumber,
						minAmount: this.redSettings.minimumAmount,
						maxAmount: this.redSettings.maximumAmount,
						isRepeatable: this.redSettings.once ? 0 : 1,
						minDuration: this.redSettings.fractionMaxNumber,
						minScore: this.redSettings.fractionMinNumber,
						money: this.Price,
						minDurationUnit: this.redSettings.timeMin ?
							this.timeColumns[this.timeType].id : ''
					})
					// this.$message.success('下单成功')
					this.PaymentShow = true
					this.PaymentData = res.data
					let base64 = this.PaymentData.qrCodeBase64
					this.PaymentData.qrCodeBase64 = base64.startsWith('data:') ?
						base64 :
						'data:image/png;base64,' + base64
					this.redStartPolling(res.data.outTradeNo)
					this.getCurrentTime = new Date().toLocaleString()
				} catch (err) {
					console.log('支付报错信息', err)
					this.$message.error('支付失败')
					this.isSubmitting = false
				}
			},
			redStartPolling(outTradeNo) {
				if (this.payTimer) {
					clearInterval(this.payTimer)
					this.payTimer = null
				}
				if (this.payTimeout) {
					clearTimeout(this.payTimeout)
					this.payTimeout = null
				}
				this.payTimer = setInterval(async () => {
					try {
						const res = await getPayment({
							outTradeNo
						})
						console.log('轮询返回', res)
						if (res.data === 'SUCCESS') {
							this.clearPayTimer()
							clearInterval(this.payTimer)
							this.payTimer = null
							clearTimeout(this.payTimeout)
							this.payTimeout = null

							this.RedEnvelopeDialogVisible = false
							this.redListShow = false
							this.redSettingsShow = false
							this.PaymentShow = false
							this.$message.success('支付成功')
							this.isSubmitting = false
							this.getData()
						}

						if (res.data === 'CLOSED') {
							this.clearPayTimer()
							clearInterval(this.payTimer)
							this.payTimer = null
							clearTimeout(this.payTimeout)
							this.payTimeout = null

							this.$message.warning('订单已关闭')
						}
					} catch (err) {
						console.error('查询支付状态失败', err)
					}
				}, 3000)
				this.payTimeout = setTimeout(() => {
					this.clearPayTimer()
					if (this.payTimer) {
						clearInterval(this.payTimer)
						this.payTimer = null
					}
					this.RedEnvelopeDialogVisible = false
					this.redListShow = false
					this.redSettingsShow = false
					this.PaymentShow = false
					this.$message.error('支付超时，请重试')
				}, 10 * 60 * 1000)
			},
			// 请求数据
			redClaimGetList() {
				console.log('11111')
				if (this.redClaim.loading || !this.redClaim.hasMore) return
				console.log('22222')
				this.redClaim.loading = true
				getClaimDetail({
					packetUuid: this.redClaim.currentUuid,
					pageNum: this.redClaim.pageNum,
					pageSize: this.redClaim.pageSize
				}).then(res => {
					const list = res.data.items || []

					this.redClaimDetail = res.data

					if (list.length < this.redClaim.pageSize) {
						this.redClaim.hasMore = false
					}

					this.redClaimData.push(...list)
					this.redClaim.pageNum++
				}).finally(() => {
					this.redClaim.loading = false
				})
			},
			// 滚动触底触发
			redClaimLoadMore() {
				console.log('this.redClaim.loading', this.redClaim.loading)
				if (this.redClaim.loading) return
				this.redClaimGetList()
			},
			clearPayTimer() {
				if (this.payTimer) {
					clearInterval(this.payTimer)
					this.payTimer = null
				}
				if (this.payTimeout) {
					clearTimeout(this.payTimeout)
					this.payTimeout = null
				}
			},
			editClick(item) {
				console.log("qweweqwe112312321", item);
				if (item.questionnaireType === "1") {
					this.$router.push({
						path: "/create",
						query: {
							id: item.uuid,
							type: "1",
						},
					});
				} else if (item.questionnaireType === "2") {
					this.$router.push({
						path: "/examCreate",
						query: {
							id: item.uuid,
							type: "2",
						},
					});
				} else {
					this.$router.push({
						path: "/evaluationCreate",
						query: {
							id: item.uuid,
							type: "3",
						},
					});
				}
			},
			// 创建副本
			copyMethod(index, item) {
				console.log(item, "item");

				copyQuestionnaire({
						uuid: item.uuid,
					})
					.then((res) => {
						if (res.code === 200) {
							this.getData();
							this.$message.closeAll();
							this.$message({
								message: "成功",
								type: "success",
							});
						} else {
							this.$message.closeAll();
							this.$message({
								message: res.msg,
								type: "failed",
							});
						}
					})
					.catch((err) => {
						console.log("err", err);
					});
			},
			// 结束问卷
			endMethod(index, item) {
				console.log(item, "item");
				closeQuestionnaire({
						uuid: item.uuid,
					})
					.then((res) => {
						if (res.code === 200) {
							this.getData();
							this.$message.closeAll();
							this.$message({
								message: "成功",
								type: "success",
							});
						} else {
							this.$message.closeAll();
							this.$message({
								message: res.msg,
								type: "failed",
							});
						}
					})
					.catch((err) => {
						console.log("err", err);
					});
			},
			deleteMethod(index, item) {
				console.log(item, "item");
				this.$confirm("确认删除此问卷吗？", "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "warning",
					})
					.then(() => {
						removeQuestionnaire({
								uuid: item.uuid,
							})
							.then((res) => {
								if (res.code === 200) {
									this.getData();
									this.$message.closeAll();
									this.$message({
										message: "删除成功",
										type: "success",
									});
								} else {
									this.$message.closeAll();
									this.$message({
										message: res.msg,
										type: "failed",
									});
								}
							})
							.catch((err) => {
								console.log("err", err);
							});
					})
					.catch(() => {});
			},
			// 重置
			getListReset() {
				// this.dateRange = []
				this.queryParams.releaseStatus = null;
				this.queryParams.questionnaireName = null;
				this.queryParams.questionnaireType = null;
				this.queryParams.userKey = null;
				this.currentPage = 1;
				this.queryParams.pageNum = 1;

				this.getData();
			},
			// 回车事件
			enterSearchOrder: function(e) {
				if (e.keyCode === 13) {
					this.queryParams.pageNum = 1;
					this.getData(); //这里的操作，是回车之后想要进行的操作，尽量全部写在一个方法里面
				}
			},
			getDataOne() {
				this.queryParams.pageNum = 1;
				this.currentPage = 1;
				this.getData();
			},
			// 查询数据
			getData() {
				this.loading = true
				userList({
						releaseStatus: this.queryParams.releaseStatus,
						pageNum: this.currentPage,
						questionnaireName: this.queryParams.questionnaireName,
						questionnaireType: this.queryParams.questionnaireType,
					}).then((response) => {
						this.tableData = response.rows;
						this.total = response.total;
					})
					.catch((err) => {
						console.log("err", err);
					})
					.finally(() => {
						this.loading = false;
					});
			},
			handleSizeChange(val) {
				this.queryParams.pageSize = val;
				this.queryParams.pageNum = 1;
				this.getData();
			},
			handleCurrentChange(val) {
				this.queryParams.pageNum = val;
				this.getData();
			},

			handlePageChange(page) {
				this.currentPage = page;
				this.queryParams.pageNum = page;
				// 这里可以添加获取新页数据的逻辑
				console.log("切换到页码:", page);
				this.getData();
			},
			// 查看详情
			handleShareClick(item) {
				//   this.clickItem = item;
				console.log("this.clickItem", item);
				//   this.dialogVisible = true;
				this.showDialog = true;
				this.lookId = item.uuid;
				this.questionnaireType = item.questionnaireType;
			},
			// 发布问卷
			fbClick(item) {
				this.$confirm(
						"当前问卷处于可编辑状态，尚未发布，是否确认现在发布？",
						"提示", {
							confirmButtonText: "确定",
							cancelButtonText: "取消",
							type: "warning",
						}
					)
					.then(() => {
						usercloseQuestionnaire({
							uuid: item.uuid,
						}).then((res) => {
							if (res.code === 200) {
								this.getData();
								this.$message.closeAll();
								this.$message({
									message: "成功",
									type: "success",
								});
							} else {
								this.$message.error("失败");
							}
						});
					})
					.catch(() => {});
			},
			copyClick() {
				// 复制逻辑
				console.log("复制链接");
				// 复制逻辑
				const input = document.createElement("input");
				input.value = this.clickItem.qrCode;
				document.body.appendChild(input);
				input.select();
				document.execCommand("copy");
				document.body.removeChild(input);
				this.$message.success("复制成功");
			},
			downloadIamge(imgsrc, name) {
				//下载图片地址和图片名
				var image = new Image();
				// 解决跨域 Canvas 污染问题
				image.setAttribute("crossOrigin", "anonymous");
				image.onload = function() {
					var canvas = document.createElement("canvas");
					canvas.width = image.width;
					canvas.height = image.height;
					var context = canvas.getContext("2d");
					// 背景设置成白色
					context.fillStyle = "#fff";
					context.fillRect(0, 0, canvas.width, canvas.height);
					context.drawImage(image, 0, 0, image.width, image.height);
					var url = canvas.toDataURL("image/png"); //得到图片的base64编码数据
					var a = document.createElement("a"); // 生成一个a元素
					var event = new MouseEvent("click"); // 创建一个单击事件
					a.download = name || "photo"; // 设置图片名称
					a.href = url; // 将生成的URL设置为a.href属性
					a.dispatchEvent(event); // 触发a的单击事件
				};
				image.src = imgsrc;
			},
			downs() {
				this.downloadIamge(this.clickItem.qrCode, "二维码");
			},
			setManager() {},
			toggleTop(index, item) {
				setQuestionnaireTop({
						uuid: item.uuid,
					})
					.then((res) => {
						if (res.code === 200) {
							this.currentPage = 1;
							this.getData();
							this.$message.closeAll();
							this.$message({
								message: "操作成功",
								type: "success",
							});
						} else {
							this.$message.closeAll();
							this.$message({
								message: res.msg,
								type: "failed",
							});
						}
					})
					.catch((err) => {
						console.log("err", err);
					});
			},
			downloadQrCode() {
				const name = this.collaboratorName;
				//下载图片地址和图片名
				var image = new Image();
				// 解决跨域 Canvas 污染问题
				image.setAttribute("crossOrigin", "anonymous");
				image.onload = function() {
					var canvas = document.createElement("canvas");
					canvas.width = image.width;
					canvas.height = image.height + 100;
					var context = canvas.getContext("2d");

					// 背景设置成白色
					context.fillStyle = "#fff";
					context.fillRect(0, 0, canvas.width, canvas.height);
					context.drawImage(image, 0, 46, image.width, image.height);

					// 添加标题
					context.fillStyle = "#000000"; // 文字颜色
					context.font = "16px Arial"; // 字体和大小
					context.textAlign = "center"; // 文字对齐方式
					context.fillText(name, canvas.width / 2, 36);

					// 添加更多文字
					context.fillStyle = "#7b818a"; // 红色文字
					context.font = "14px";
					context.textAlign = "center";
					context.fillText(
						"请扫码进入小程序邀请管理员",
						canvas.width / 2,
						canvas.height - 26
					);

					var url = canvas.toDataURL("image/png"); //得到图片的base64编码数据
					var a = document.createElement("a"); // 生成一个a元素
					var event = new MouseEvent("click"); // 创建一个单击事件
					a.download = name || "photo"; // 设置图片名称
					a.href = url; // 将生成的URL设置为a.href属性
					a.dispatchEvent(event); // 触发a的单击事件
				};
				image.src = this.collaboratorQrCode;
				this.showCollaborator = false;
			},
			openEamilDialog(row) {
				this.EamilDialogVisible = true
				this.emailList.currentUuid = row.uuid
				this.emailListGetList()
			},
			emailListGetList() {
				if (this.emailList.loading || !this.emailList.hasMore) return
				this.emailList.loading = true
				getEmailTaskList({
					uuid: this.emailList.currentUuid,
					pageNum: this.emailList.pageNum,
					pageSize: this.emailList.pageSize
				}).then(res => {
					const list = res.rows || []

					if (list.length < this.emailList.pageSize) {
						this.emailList.hasMore = false
					}

					this.emailListData.push(...list)
					this.emailList.pageNum++
				}).finally(() => {
					this.emailList.loading = false
				})
			},
			// 滚动触底触发
			emailLoadMore() {
				if (this.emailList.loading) return
				this.emailListGetList()
			},
			emailAddRedEnvelope() {
				this.emailListShow = false
				this.emailSettingsShow = true
				this.emailSettings.name = localStorage.getItem('nickname')
				this.onInsert();
			},
			emailOnTextareaInput() {
				this.emailTextNumber = this.emailSettings.content.length
			},
			emailHandleSelect() {
				const input = document.createElement('input')
				input.type = 'file'
				input.multiple = true
				input.accept = 'image/*'
				input.onchange = (e) => {
					const files = Array.from(e.target.files)
					this.emailUploadImages(files)
				}
				input.click()
			},
			emailUploadImages(files) {
				const limitSize = 5
				const maxImages = 3
				const totalImages = this.emailImageList.length + files.length
				if (totalImages > maxImages) {
					this.$message.error(`最多只能上传${maxImages}张图片，当前已有${this.emailImageList.length}张`)
					return
				}
				const limitImages = files.filter(item => item.size <= limitSize * 1024 * 1024)
				let uploadData = []
				this.$message.success('上传中')
				const UploadFile = (file) => {
					const formData = new FormData()
					formData.append('file', file)
					formData.append('uuid', localStorage.getItem('uuid'))
					return fetch(process.env.API_BASE_URL + '/PCwj/file/uploads', {
							method: 'POST',
							headers: {
								'token': localStorage.getItem('token')
							},
							body: formData
						})
						.then(response => response.json())
						.then(data => {
							uploadData.push(data.urls)
						})
				}
				limitImages.reduce((p, next) => p.then(() => UploadFile(next)), Promise.resolve())
					.then(() => {
						this.emailImageList = this.emailImageList.concat(uploadData)
						console.log('emailImageList', this.emailImageList)
						if (limitImages.length < files.length) {
							this.$message.error(
								`图片过大，${files.length - limitImages.length}张超出 ${limitSize}M`
							)
						}
					})
					.catch(error => {
						console.error('上传失败:', error)
					})
			},
			emailHandleUpdate(e) {
				const value = e.target.value || ''
				const count = value
					.split(/\r?\n/)
					.map(v => v.trim())
					.filter(Boolean)
					.length
				this.emailConsumption = count
			},
			emailOnExcel() {
				this.emailUploadShow = true
			},
			emailRecharge() {
				this.Recharge = true
				this.rechargeTitle = '购买邮件'
				getProductEmail().then(res => {
					this.tabList = res.data || []
				})
			},
			emailPaymentSubmit() {
				if (this.emailIsSubmitting) return
				if (!this.emailSettings.name) {
					this.$message.error('请输入发件人')
					return
				}
				if (!this.emailSettings.theme) {
					this.$message.error('请输入邮件主题')
					return
				}
				if (!this.emailSettings.content) {
					this.$message.error('请输入邮件内容')
					return
				}
				if (!this.emailSettings.list) {
					this.$message.error('请输入收件人邮箱')
					return
				}
				const parsed = this.parseRecipientList(this.emailSettings.list)
				if (!parsed.valid) {
					this.$message.error(`第 ${parsed.errorLine} 行${parsed.errorMsg}`)
					return
				}

				if (this.emailBalance <= 0) {
					this.emailPromptShow = true
					this.emailSettings.scene = 'balance'
					return
				}

				console.log('最终发送收件人：', parsed.list)

				if (!this.emailSettings.agree) {
					this.emailPromptShow = true
					this.emailSettings.scene = 'policy'
					return
				}
				
				this.emailIsSubmitting = true

				const imgsHtml = this.emailImageList.map(url => `<img src="${url}"/>`).join('')
				const contentWithLink = this.emailSettings.content.replace(
					this.generateUrls,
					`<a href="${this.generateUrls}">${this.generateUrls}</a>`
				)
				const sendStr = contentWithLink + imgsHtml
				console.log("sendStr", sendStr)

				postEmailCreateQuestionnaireEmailTask({
					uuid: this.ActivityUuid,
					subject: this.emailSettings.theme,
					content: sendStr,
					recipients: this.emailSettings.list
				}).then(res => {
					this.$message.success('发送成功')
					this.handleDialogClose()
					console.log('res', res)
				}).catch(error => {
					console.error('发送失败:', error)
					this.$message.error('发送失败，请重试')
				}).finally(() => {
					this.emailIsSubmitting = false
				})
			},
			onInsert(flag) {
				if (flag) {
					this.$message.success('生成链接中...')
				}
				getUrlLink({
					path: this.questionnaireType === '1' ? 'pages-other/QuestionDetails/QuestionDetails' :
						'pages-other/ExamDetails/ExamDetails',
					query: `operate=3&uuid=${this.ActivityUuid}`
				}).then(res => {
					console.log('res', res.msg)
					this.generateUrls = res.msg
					this.emailSettings.content = this.emailSettings.content.replace(
						/(填写地址：)([^，。\n]*)/,
						`$1${res.msg}`
					)
					this.emailTextNumber = this.emailSettings.content.length
				})
			},
			emailUploadExcel() {
				const input = document.createElement('input')
				input.type = 'file'
				input.accept = '.xls,.xlsx'
				input.onchange = (e) => {
					const file = e.target.files[0]
					if (!file) return
					const isExcel = /\.(xls|xlsx)$/i.test(file.name)
					if (!isExcel) {
						this.$message.error('只能上传 Excel 文件')
						return
					}
					this.uploadExcelFile(file)
				}
				input.click()
			},
			uploadExcelFile(file) {
				this.$message.success('正在上传...')
				const formData = new FormData()
				formData.append('file', file)
				formData.append('type', 'excel')
				return fetch(process.env.API_BASE_URL + '/PCwj/email/importRecipientsExcel', {
						method: 'POST',
						headers: {
							'token': localStorage.getItem('token')
						},
						body: formData
					})
					.then(response => response.json())
					.then(data => {
						const code = data.code || ''
						const msg = data.msg || ''
						this.emailUploadShow = false
						if (code === 200) {
							this.$message.success('上传成功')
							const result = msg.split(/\r?\n|↵/).map(v => v.trim()).filter(Boolean).join('\n')
							const merged = [...(this.emailSettings.list || '').split('\n'), ...result.split('\n')]
								.map(v => v.trim())
								.filter(Boolean)
							this.emailSettings.list = Array.from(new Set(merged)).join('\n')
							const parsed = this.parseRecipientList(this.emailSettings.list)
							this.emailConsumption = parsed.count
						} else {
							this.$message.error(msg)
						}
					})
					.catch(error => {
						console.error('上传失败:', error)
					})
			},
			parseRecipientList(value) {
				if (!value) {
					return {
						valid: true,
						list: [],
						count: 0
					}
				}
				const lines = value.split(/\r?\n/).map(v => v.trim()).filter(Boolean)
				if (lines.length > 100) {
					return {
						valid: false,
						errorMsg: '单次最多可发送100条'
					}
				}
				for (let i = 0; i < lines.length; i++) {
					const line = lines[i]
					const parts = line.split(/,|，/)
					if (parts.length !== 2) {
						return {
							valid: false,
							errorLine: i + 1,
							errorMsg: '必须为"名字,邮箱"格式'
						}
					}
					const email = parts[1].trim()
					const name = parts[0].trim()
					if (!email || !name) {
						return {
							valid: false,
							errorLine: i + 1,
							errorMsg: '邮箱或名字不能为空'
						}
					}
					if (!this.emailReg.test(email)) {
						return {
							valid: false,
							errorLine: i + 1,
							errorMsg: '邮箱格式不正确'
						}
					}
				}
				return {
					valid: true,
					list: lines,
					count: lines.length
				}
			},
			async emailDownloadTemplate() {
				try {
					const url = 'https://ossfastmake.mustke.com/wenjuan/wenjian/邮箱模版-1770111010503.xlsx'
					const response = await fetch(url)
					const blob = await response.blob()
					const link = document.createElement('a')
					link.href = URL.createObjectURL(blob)
					link.download = '邮箱模版.xlsx'
					document.body.appendChild(link)
					link.click()
					document.body.removeChild(link)
					URL.revokeObjectURL(link.href)
					this.$message.success('下载成功')
					this.emailUploadShow = false
				} catch (error) {
					console.error('下载失败:', error)
					this.$message.error('下载失败')
				}
			},
			onSelect(e, i) {
				this.activeIndex = i
			},
			buyNow() {
				postEmailBuy({
					productId: this.tabList[this.activeIndex].id,
					quantity: 1
				}).then(res => {
					// this.$message.success('下单成功')
					this.PaymentShow = true
					this.PaymentData = res.data
					let base64 = this.PaymentData.qrCodeBase64
					this.PaymentData.qrCodeBase64 = base64.startsWith('data:') ?
						base64 :
						'data:image/png;base64,' + base64
					this.Price = this.tabList[this.activeIndex].currentPrice
					this.redStartPolling(res.data.outTradeNo)
					this.getCurrentTime = new Date().toLocaleString()
				}).catch(() => {

				})
			},
			getRemainingBalanceData() {
				getRemainingBalance().then(res => {
					this.emailBalance = res.data.emailSendTimes
				})
			},
			emailOnDetails(e) {
				this.emailRecordData = []
				this.emailListShow = false
				this.emailRecordShow = true
				this.emailTitle = '详情'
				console.log("e", e)
				this.emailRecord.currentUuid = e.id
				this.emailRecord.loading = false
				this.emailRecord.hasMore = true
				this.emailRecordGetList()
			},
			// 请求数据
			emailRecordGetList() {
				console.log('11111')
				if (this.emailRecord.loading || !this.emailRecord.hasMore) return
				console.log('22222')
				this.emailRecord.loading = true
				getTaskDetailList({
					emailTaskId: this.emailRecord.currentUuid,
					pageNum: this.emailRecord.pageNum,
					pageSize: this.emailRecord.pageSize
				}).then(res => {
					const list = res.rows || []

					if (list.length < this.emailRecord.pageSize) {
						this.emailRecord.hasMore = false
					}

					this.emailRecordData.push(...list)
					this.emailRecord.pageNum++
				}).finally(() => {
					this.emailRecord.loading = false
				})
			},
			// 滚动触底触发
			emailRecordLoadMore() {
				if (this.emailRecord.loading) return
				this.emailRecordGetList()
			},
			resendEmail(e) {
				postRetrySend({
					id: e.id
				}).then(res => {
					if (res.code === 200) {
						this.$message.success('发送成功')
					} else {
						this.$message.error('发送失败')
					}
					this.handleDialogClose()
				})
			}
		},
	};
</script>

<style scoped>
	.el-main {
		background-color: #f6f6fb;
	}

	.huise {
		width: 100%;
		height: 100vh;
		background-color: rgba(000, 000, 000, 0.3);
		display: flex;
		align-items: center;
		justify-content: center;
		position: fixed;
		top: 0;
		left: 0;
		z-index: 9;
	}

	.tanchuang {
		min-width: 397px;
		padding: 0 0 20px 0;
		box-sizing: border-box;
		display: flex;
		align-items: center;
		flex-direction: column;
		background-color: #ffffff;
		position: relative;
	}

	.tanchuang .el-icon-close {
		position: absolute;
		right: 13px;
		top: 18px;
		cursor: pointer;
	}

	.tanchuang .top1 {
		width: 100%;
		height: 50px;
		background-color: #eaeaea;
		display: flex;
		align-items: center;
		justify-content: center;
		margin-bottom: 17px;
	}

	.tanchuang .content1 {
		width: 100%;
		display: flex;
		flex-direction: column;
		padding: 0 40px;
		box-sizing: border-box;
	}

	.tanchuang .content1 .allview {
		display: flex;
		align-items: flex-start;
		margin-bottom: 17px;
	}

	.tanchuang .content1 .allview span {
		display: block;
		width: 95px;
		font-size: 16px;
		color: #6a6a6a;
		text-align: end;
	}

	.tanchuang .content1 .allview div {
		font-size: 16px;
		color: #6a6a6a;
	}

	.tanchuang .el-button {
		background-color: #086ed9;
		color: #ffffff;
		cursor: pointer;
	}

	.bigcontent {
		padding: 0 10px;
		width: calc(100% - 20px);
		box-sizing: border-box;
		height: 100%;
		overflow: hidden;
		overflow-y: auto;
		background: #ffffff;
	}

	.bigcontent .top {
		background-color: #ffffff;
		padding: 20px;
	}

	.bigcontent .top .topfirst {
		display: flex;
		align-items: center;
	}

	.bigcontent .top .topfirst .inpstyle {
		display: flex;
		align-items: center;
		margin-right: 30px;
	}

	.bigcontent .top .topfirst .inpstyle p {
		font-size: 14px;
		color: #2f4257;
		white-space: nowrap;
		margin-right: 10px;
	}

	/deep/ .inpstyle .el-select .el-input .el-input__inner {
		border: 1px solid #e6e6e6;
	}

	.bigcontent .content {
		background: #fff;
	}

	.bigcontent .content .isReleaseTrue {
		background: #fea951;
		border-radius: 10px;
		padding: 5px 8px;
		color: #fff;
	}

	.bigcontent .content .isReleaseFalse {
		background: #d8d8d8;
		border-radius: 10px;
		padding: 5px 8px;
		color: #fff;
	}

	.bigcontent .content .custom-questionnaire-column {}

	/deep/.bigcontent .content .custom-questionnaire-column .cell {
		padding-left: 20px;
	}

	.bigcontent .content .custom-questionnaire-column .text {
		display: block;
		width: 88%;
	}

	.bigcontent .content .custom-questionnaire-column .ifTop {
		color: #00b380;
		text-align: center;
		font-size: 12px;
		line-height: 24px;
		margin-right: 12px;
		background: linear-gradient(180deg,
				rgba(0, 179, 128, 0.11),
				rgba(0, 179, 128, 0));
		border-radius: 10px;
		padding: 0px 8px;
		position: absolute;
		top: 0;
		right: 0;
		margin: 0;
	}

	.betweenFlx {
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.flexStart {
		display: flex;
		align-items: center;
		justify-content: flex-start;
	}

	.pagination {
		padding-bottom: 10px;
	}

	.el-pagination {
		float: right;
	}

	.el-table .el-table__header-wrapper th,
	.el-table .el-table__fixed-header-wrapper th {
		background-color: #edf2fa;
	}

	.el-drawer__container {
		position: relative;
		top: 200px;
		right: 40%;
	}

	.bigcontent1 {
		width: 100%;
		height: 420px;
		padding: 10px;
		box-sizing: border-box;
	}

	.bigcontent1 .alldiv {
		background-color: #ffffff;
		padding: 18px;
		box-sizing: border-box;
		height: 420px;
		overflow: auto;
	}

	.bigcontent1 .biao {
		width: 100%;
		display: flex;
		align-items: center;
	}

	.bigcontent1 .biao span {
		display: block;
		width: 5px;
		height: 14px;
		background-color: #5174f0;
		border-radius: 2px;
		margin-right: 10px;
	}

	.bigcontent1 .biao h2 {
		font-size: 16px;
		color: #0f0f0f;
	}

	.bigcontent1 .allinp {
		padding: 10px 20px;
		box-sizing: border-box;
		display: flex;
		align-items: center;
	}

	.bigcontent1 .allinp .inpstyle {
		min-width: 240px;
		display: flex;
		flex-direction: column;
		margin-right: 30px;
	}

	.bigcontent1 .allinp .inpstyle span {
		font-size: 16px;
		color: #2f4257;
		margin-bottom: 3px;
	}

	.bigcontent1 .allinp .inpstyle el-input {
		width: 100%;
	}

	.bigcontent1 .allinp .selBiao {
		font-size: 16px;
		margin-right: 10px;
		font-weight: 600;
	}

	.bigcontent1 .allinp .selStyle {
		display: flex;
		align-items: center;
		margin-bottom: 10px;
	}

	.bigcontent1 .allinp .selStyle span {
		font-size: 14px;
		color: #0f0f0f;
		margin-right: 10px;
	}

	.bigcontent1 .message {}

	.bigcontent1 .message span {
		font-size: 14px;
		color: #5174f0;
		margin-bottom: 12px;
		cursor: pointer;
	}

	.bigcontent1 .footer {
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		margin-top: 20px;
	}

	.left-panel {
		background: #007aff;
		color: white;
		border-radius: 10px;
		padding: 30px;
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.logo {
		width: 120px;
		margin-bottom: 15px;
	}

	.beta {
		background: yellow;
		color: black;
		padding: 5px 10px;
		border-radius: 3px;
		margin-bottom: 20px;
	}

	.title {
		font-size: 36px;
		margin-bottom: 30px;
	}

	.card {
		background: white;
		color: #007aff;
		padding: 25px;
		border-radius: 8px;
		text-align: center;
		margin-bottom: 20px;
		display: flex;
		align-items: center;
		flex-direction: column;
	}

	.card-title {
		font-size: 24px;
		margin-bottom: 15px;
		display: inline-block;
		max-width: 14ch;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.qr-code {
		width: 180px;
	}

	.footer {
		display: flex;
		align-items: center;
		margin-top: auto;
	}

	.mini-logo {
		width: 40px;
		margin-right: 10px;
	}

	.right-panel {
		flex: 1;
		padding-left: 40px;
	}

	.info-box,
	.link-box {
		margin-bottom: 30px;
	}

	.info-title,
	.link-title {
		color: #007aff;
		border-bottom: 2px solid #007aff;
		padding-bottom: 5px;
		margin-bottom: 15px;
	}

	.info-item {
		margin: 8px 0;
	}

	.link-input {
		width: 100%;
		padding: 10px;
		margin-bottom: 15px;
		border: 1px solid #ddd;
		border-radius: 4px;
	}

	.btn-group {
		display: flex;
		gap: 15px;
		margin-top: 10px;
	}

	.btn {
		background: #007aff;
		color: white;
		border: none;
		padding: 10px 20px;
		border-radius: 4px;
		cursor: pointer;
	}

	.close-btn {
		background: #007aff;
		color: white;
		border: none;
		padding: 12px 25px;
		border-radius: 4px;
		font-size: 16px;
	}

	.el-dropdown-link {
		cursor: pointer;
		color: #007aff;
		font-size: 12px;
	}

	.el-icon-arrow-down {
		font-size: 12px;
	}

	.coverShow {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		z-index: 1009;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}

	.container-gj {
		position: fixed;
		top: 50%;
		left: 50%;
		width: 100%;
		height: 100%;
		background: rgba(0, 0, 0, 0.65);
		z-index: 1009;
		transform: translate(-50%, -50%);
	}

	.container-gd {
		position: fixed;
		top: 50%;
		left: 50%;
		background: #ffffff;
		z-index: 1009;
		transform: translate(-50%, -50%);
		overflow: hidden;
		border-radius: 10px;
	}

	.container-gd::-webkit-scrollbar {
		display: none;
	}

	.header {
		width: 100%;
		height: 55px;
		border-bottom: 1px solid #e7e7e7;
		position: relative;
	}

	.header p {
		font-size: 18px;
		font-weight: 500;
		color: #333333;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		font-weight: 600;
	}

	.header i {
		font-size: 20px;
		font-weight: 500;
		color: #333333;
		position: absolute;
		top: 50%;
		right: 10px;
		transform: translateY(-50%);
	}

	.download-btn {
		font-size: 14px;
		font-weight: 500;
		color: #ffffff;
		background: #3a60ff;
		cursor: pointer;
		height: 44px;
		width: 50%;
		border-radius: 22px;
		margin-left: 25%;
		margin-top: 20px;
		margin-bottom: 20px;
	}

	/deep/ .el-dialog__header {
		border-bottom: 1px solid #f2f2f2;
		text-align: center;
	}

	/deep/ .el-dialog--center {
		border-radius: 10px;
	}

	.dialogClose {
		width: 20px;
		height: 20px;
		border-radius: 50%;
		background: #8690A2;
		position: absolute;
		top: 20px;
		right: 20px;
		cursor: pointer;
	}

	.dialogClose::before,
	.dialogClose::after {
		display: block;
		content: "";
		width: 8px;
		height: 1px;
		background: #fff;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%) rotate(45deg);
	}

	.dialogClose::after {
		transform: translate(-50%, -50%) rotate(-45deg);
	}

	.redList,
	.emailList,
	.emailRecord {
		height: 60vh;
		overflow-y: auto;
	}

	.redList.noData,
	.emailList.noData,
	.emailRecord.noData {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}

	.redList .item,
	.emailList .item,
	.emailRecord .item {
		position: relative;
		background: #ffffff;
		border-radius: 5px;
		box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.07);
		padding: 13px;
		flex-direction: column;
		align-items: center;
		justify-content: space-between;
	}

	.redList .item+.item,
	.emailList .item+.item,
	.emailRecord .item+.item {
		margin-top: 10px;
	}

	.redList .item .title {
		display: flex;
		width: 100%;
		font-size: 15px;
		font-weight: bold;
		color: #323b5a;
		line-height: 1;
		padding-bottom: 10px;
		border-bottom: 1px solid #e5e5e5;
		margin-bottom: 10px;
	}

	.redList .item .title img {
		display: block;
		width: 13px;
		height: 15px;
		margin-right: 9px;
	}

	.redList .item .collection {
		width: 100%;
		font-size: 12px;
		color: #7e7e81;
		margin-top: 5px;
	}

	.redList .item .collection span {
		color: #6079F1;
		margin-left: 9px;
		cursor: pointer;
	}

	.redList .item .name,
	.redList .item .probability,
	.redList .item .condition,
	.redList .item .addTime {
		width: 100%;
		font-size: 12px;
		color: #7e7e81;
		margin-top: 5px;
	}

	.redList .loading,
	.redList .noMore,
	.redClaim .loading,
	.redClaim .noMore,
	.emailRecord .noMore {
		margin: 10px auto;
		text-align: center;
	}

	.redList .button,
	.emailList .button {
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
		width: 156px;
		height: 38px;
		background: #3a60ff;
		border-radius: 4px;
		font-size: 14px;
		font-family: PingFang SC, PingFang SC-Semibold;
		font-weight: Semibold;
		text-align: left;
		color: #ffffff;
		margin: 10px auto;
	}

	.redSettings,
	.emaiSettings {
		min-height: 60vh;
		max-height: 80vh;
		overflow-x: hidden;
	}

	.redSettings .heading,
	.emaiSettings .heading {
		position: relative;
		font-weight: 600;
		color: #4C4A56;
		font-size: 14px;
		text-indent: 10px;
		background: #ffffff;
	}

	.redSettings .heading::before,
	.emaiSettings .heading::before {
		display: block;
		content: "";
		width: 4px;
		height: 16px;
		background: #3a60ff;
		border-radius: 5px;
		position: absolute;
		top: 0;
		left: 0;
	}

	.redSettings .content,
	.emaiSettings .content {
		display: grid;
		grid-template-columns: 1fr 1fr;
		grid-template-columns: 1fr 1fr;
		row-gap: 10px;
		column-gap: 13px;
		padding: 13px 0;
		width: calc(100% - 25px);
		background: #ffffff;
	}

	.redSettings .content .item,
	.emaiSettings .content .item {
		display: contents;
		gap: 20px;
	}

	.redSettings .content .item .box,
	.emaiSettings .content .item .box {
		display: flex;
		align-items: center;
		gap: 10px;
	}

	.redSettings .content .item .label,
	.emaiSettings .content .item .label {
		display: flex;
		font-size: 14px;
		font-weight: Bold;
		color: #323b5a;
		align-items: center;
	}

	.redSettings .content .item .label.switch {
		align-items: center;
		position: relative;
		cursor: pointer;
	}

	.redSettings .content .item .label.switch::before {
		display: block;
		content: "";
		width: 16px;
		height: 16px;
		border: 1px solid #d5d5d5;
		border-radius: 4px;
		margin-right: 8px;
	}

	.redSettings .content .item .label.switch.checked::before {
		border-color: #4A73F8;
		background: #4A73F8;
	}

	.redSettings .content .item .label.switch.checked::after {
		display: block;
		content: "";
		width: 4px;
		height: 8px;
		border: 2px solid #fff;
		border-top: none;
		border-left: none;
		position: absolute;
		top: 50%;
		left: 6px;
		transform: translate(0, -50%) rotate(45deg);
		margin-top: -1px;
	}

	.redSettings .content .item .region,
	.emaiSettings .content .item .region {
		display: flex;
		font-size: 14px;
		font-weight: Regular;
		color: #4c4a56;
		align-items: center;
		flex: 1;
	}

	.redSettings .content .item .region input,
	.emaiSettings .content .item .region input {
		width: 100%;
		height: 37px;
		border: 1px solid #d5d5d5;
		border-radius: 7px;
		padding: 0 13px;
	}

	.redSettings .content .item .region .unit {
		margin-left: 8px;
	}

	.redSettings .content .item .region .segmentation {
		margin: 0 10px;
	}

	.redSettings .content .item .region .option {
		display: flex;
		align-items: center;
		position: relative;
		cursor: pointer;
	}

	.redSettings .content .item .region .option+.option {
		margin-left: 22px;
	}

	.redSettings .content .item .region .option::before {
		display: block;
		content: "";
		width: 16px;
		height: 16px;
		border: 1px solid #d5d5d5;
		border-radius: 10px;
		margin-right: 8px;
	}

	.redSettings .content .item .region .option.active::after {
		display: block;
		content: "";
		width: 10px;
		height: 10px;
		border-radius: 25px;
		background: #4A73F8;
		position: absolute;
		top: 50%;
		left: 3px;
		transform: translate(0, -50%);
	}

	/deep/ .redSettings .content .item .region .el-select {
		width: 75px;
		height: 37px;
		line-height: 1;
		border: 1px solid #d5d5d5;
		border-radius: 7px;
		padding: 0 2px 0 10px;
		margin-left: 10px;
	}

	/deep/ .redSettings .content .item .region .el-select .el-input {
		height: 100%;
	}

	/deep/ .redSettings .content .item .region .el-select .el-input .el-input__inner {
		height: 100%;
		padding: 0;
	}

	/deep/ .redSettings .content .item .region .el-select .el-input__suffix-inner {
		margin-right: -3px;
	}

	/deep/ .redSettings .content .item .region .el-select .el-input__suffix-inner .el-input__icon {
		line-height: 1;
	}

	.redSettings .kindReminder,
	.emaiSettings .kindReminder {
		padding: 13px 0;
		margin-top: 10px;
		background: #fff;
	}

	.redSettings .kindReminder .title,
	.emaiSettings .kindReminder .title {
		font-size: 13px;
		color: #7e7e81;
		font-weight: bold;
		display: flex;
		align-items: center;
		gap: 7px;
		margin: 0;
	}

	.redSettings .kindReminder .title img,
	.emaiSettings .kindReminder .title img {
		width: 14px;
		height: 14px;
	}

	.redSettings .kindReminder .text,
	.emaiSettings .kindReminder .text {
		font-size: 13px;
		color: #7e7e81;
		margin-top: 10px;
		line-height: 1.6;
	}

	.redSettings .kindReminder .text div,
	.emaiSettings .kindReminder .text div {
		color: #F73B42;
	}

	.redSettings .kindReminder .text span,
	.emaiSettings .kindReminder .text span {
		color: #4A73F8;
	}

	.redSettings .settlement {
		margin-top: 28px;
	}

	.redSettings .settlement .totalAmount {
		font-size: 16px;
		color: #323b5a;
		font-weight: bold;
		align-items: center;
		justify-content: flex-end;
	}

	.redSettings .settlement .totalAmount .number {
		color: #F73B42;
	}

	.redSettings .settlement .totalAmount .remark {
		font-size: 14px;
		margin-left: 5px;
		font-weight: normal;
	}

	.redSettings .settlement .button {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 156px;
		height: 38px;
		background: #3a60ff;
		border-radius: 4px;
		font-size: 15px;
		color: #ffffff;
		margin: 24px auto 0;
		cursor: pointer;
	}

	.redSettings .settlement .button.disabled {
		opacity: 0.5;
		pointer-events: none;
	}

	.Payment,
	.emailUpload,
	.Recharge,
	.emailPrompt,
	.emailPolicy {
		position: fixed;
		top: 0;
		left: 0;
		z-index: 99999;
		width: 100%;
		height: 100%;
		background: #00000050;
	}

	.Payment .content,
	.emailUpload .content,
	.Recharge .content,
	.emailPrompt .content,
	.emailPolicy .content {
		width: 312px;
		height: 344px;
		background: #ffffff;
		border-radius: 8px;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
	}

	.Payment .content .title,
	.emailUpload .content .title,
	.Recharge .content .title,
	.emailPrompt .content .title,
	.emailPolicy .content .title {
		height: 50px;
		border-bottom: 1px solid #f2f2f2;
		display: flex;
		align-items: center;
		justify-content: center;
		text-align: center;
		font-size: 16px;
		font-family: Microsoft YaHei, Microsoft YaHei-Bold;
		font-weight: Bold;
		color: #333333;
		position: relative;
		margin-bottom: 0;
	}

	.Payment .content .title .dialogClose,
	.emailUpload .content .title .dialogClose,
	.Recharge .content .title .dialogClose,
	.emailPrompt .content .title .dialogClose,
	.emailPolicy .content .title .dialogClose {
		top: 15px;
		right: 15px;
	}

	.Payment .content {
		width: 440px;
		height: auto;
		padding-bottom: 20px;
	}

	.Payment .content .region {
		padding: 15px;
		display: flex;
		flex-direction: column;
		gap: 5px;
	}

	.Payment .content .region .item {
		font-size: 12px;
		font-family: PingFang SC, PingFang SC-Regular;
		font-weight: Regular;
		color: rgba(58, 58, 60, 0.98);
	}

	.Payment .content .region .item span {
		font-size: 18px;
		font-family: PingFang SC, PingFang SC-Regular;
		font-weight: Regular;
		color: rgba(247, 59, 66, 0.98);
	}

	.Payment .content .code {
		padding: 15px;
	}

	.Payment .code {
		position: relative;
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 10px;
	}
	
	.Payment .code .brand {
		width: 120px;
		height: auto;
	}

	.Payment .code .image {
		width: 180px;
		height: 180px;
		background: #ffffff;
		border: 1px solid #eaeaea;
		/* position: absolute;
		bottom: 34px;
		left: 20px; */
	}
	
	.Payment .code span {
		font-size: 16px;
	}

	.redClaim {
		height: 60vh;
		overflow-y: auto;
		margin-top: -15px;
	}

	.redClaim .text {
		font-size: 12px;
		font-family: PingFang SC, PingFang SC-Regular;
		font-weight: Regular;
		color: #7e7e81;
		margin-bottom: 15px;
	}

	.redClaim.noData,
	.emailList.noData {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}

	.redClaim .item {
		position: relative;
		background: #ffffff;
		border-radius: 5px;
		box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.07);
		padding: 13px;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.redClaim .item+.item {
		margin-top: 10px;
	}

	.redClaim .item .west {
		display: flex;
		align-items: center;
	}

	.redClaim .item .west img {
		width: 50px;
		height: 50px;
		border-radius: 50%;
		margin-right: 12px;
	}

	.redClaim .item .region .name {
		font-size: 15px;
		font-family: PingFang SC, PingFang SC-Medium;
		font-weight: Medium;
		color: #323b5a;
	}

	.redClaim .item .region .time {
		margin-top: 2px;
		font-size: 12px;
		font-family: PingFang SC, PingFang SC-Regular;
		font-weight: Regular;
		color: #7e7e81;
	}

	.redClaim .item .east {
		font-weight: bold;
		font-size: 16px;
		font-family: PingFang SC, PingFang SC-Medium;
		font-weight: Medium;
		text-align: left;
		color: #f73b42;
	}

	.emailList .item .strip {
		font-size: 13px;
		font-weight: bold;
		color: #3c4252;
		margin-top: 5px;
	}

	.emailList .item .strip span {
		font-weight: normal;
	}

	.emailList .item .strip span.details {
		margin-left: 10px;
		color: #1877FF;
		cursor: pointer;
	}

	.emaiSettings .content {
		position: relative;
	}

	.emaiSettings .content.special {
		display: flex;
		flex-direction: column;
	}

	.emaiSettings .content .item .region.special {
		flex-direction: column;
		align-items: flex-start;
		border: 1px solid #d5d5d5;
		border-radius: 6px;
		padding: 8px 12px;
	}

	.emaiSettings .content .item .region textarea {
		width: 100%;
		height: 101px;
		resize: none;
	}

	.emaiSettings .content .item .region .image-list {
		display: flex;
		align-items: center;
		gap: 5px;
	}

	.emaiSettings .content .item .region .image-list div img {
		width: 80px;
		height: 80px;
		border-radius: 5px;
	}

	.emaiSettings .content .item .region .image-list .block {
		background: #EEEEEE;
		width: 80px;
		height: 80px;
		border-radius: 5px;
		border: 1px dashed #DDDDDD;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		cursor: pointer;
	}

	.emaiSettings .content .item .region .image-list .block .icon {
		width: 20px;
		height: 20px;
		position: relative;
	}

	.emaiSettings .content .item .region .image-list .block .icon::before,
	.emaiSettings .content .item .region .image-list .block .icon::after {
		display: block;
		content: "";
		width: 100%;
		height: 2px;
		background: #000;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
	}

	.emaiSettings .content .item .region .image-list .block .icon::after {
		transform: translate(-50%, -50%) rotate(90deg);
	}

	.emaiSettings .content .item .region .image-list .block .text {
		margin-top: 15px;
		font-size: 12px;
		color: #999;
	}

	.emaiSettings .content .item .region .bottom {
		display: flex;
		align-items: center;
		justify-content: space-between;
		width: 100%;
		margin-top: 15px;
	}

	.emaiSettings .content .item .region .bottom .insert {
		font-size: 14px;
		color: #4A61FA;
		text-decoration: underline;
		cursor: pointer;
	}

	.emaiSettings .content .item .region .bottom .character {
		font-size: 14px;
		color: #909090;
	}

	.emaiSettings .content .item .region.end {
		align-items: flex-end;
	}

	.emaiSettings .content .item .region .import {
		display: flex;
		background: #eff1f4;
		font-size: 12px;
		color: #676d77;
		align-items: center;
		padding: 6px 10px;
		border-radius: 4px;
		cursor: pointer;
	}

	.emaiSettings .content .item .region .import img {
		width: 12px;
		height: 12px;
		margin-right: 6px;
	}

	.emaiSettings .settlement .information {
		display: flex;
		align-items: center;
	}

	.emaiSettings .settlement .information .text {
		font-size: 12px;
		font-family: Microsoft YaHei, Microsoft YaHei-Regular;
		font-weight: Regular;
		color: #323b5a;
	}

	.emaiSettings .settlement .information .text span {
		color: #1877FF;
		font-weight: bold;
	}

	.emaiSettings .settlement .information .recharge {
		font-size: 12px;
		color: #1877FF;
		font-weight: bold;
		margin-left: 15px;
		cursor: pointer;
	}

	.emaiSettings .kindReminder {
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.emaiSettings .kindReminder .west {
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.emaiSettings .kindReminder .west .button {
		width: 156px;
		height: 38px;
		background: #3a60ff;
		border-radius: 4px;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 14px;
		font-family: PingFang SC, PingFang SC-Semibold;
		font-weight: Semibold;
		color: #ffffff;
		cursor: pointer;
	}

	.emaiSettings .kindReminder .west .policy {
		font-size: 11px;
		font-family: Microsoft YaHei, Microsoft YaHei-Regular;
		font-weight: Regular;
		color: #323b5a;
		display: flex;
		align-items: center;
		margin-top: 10px;
		cursor: pointer;
		position: relative;
	}

	.emaiSettings .kindReminder .west .policy::before {
		display: block;
		content: "";
		width: 14px;
		height: 14px;
		border-radius: 4px;
		border: 1px solid #bcbcbc;
		margin-right: 8px;
	}

	.emaiSettings .kindReminder .west .policy.checked::before {
		background: #3a60ff;
		border: 1px solid #3a60ff;
	}

	.emaiSettings .kindReminder .west .policy.checked::after {
		display: block;
		content: "";
		width: 4px;
		height: 7px;
		border: 1px solid #fff;
		border-top: none;
		border-left: none;
		position: absolute;
		top: 50%;
		left: 4px;
		-webkit-transform: translate(0, -50%) rotate(45deg);
		transform: translate(0, -50%) rotate(45deg);
		margin-top: -1px;
		margin-left: 1px;
	}

	.emailUpload .content .region {
		height: calc(100% - 50px);
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}

	.emailUpload .content .upload {
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
		cursor: pointer;
	}

	.emailUpload .content .upload img {
		width: 66px;
		height: 53px;
	}

	.emailUpload .content .upload div {
		font-size: 17px;
		font-weight: bold;
		color: #566279;
	}

	.emailUpload .content .text {
		margin-top: 40px;
		font-size: 13px;
		color: #7e7e81;
	}

	.emailUpload .content .contact {
		font-size: 13px;
		color: #4a73f8;
		margin-top: 5px;
		cursor: pointer;
	}

	.Recharge .content {
		height: auto;
		background: linear-gradient(135deg, #fffaf1, #fff1de 98%), linear-gradient(135deg, #fffaf1, #fff9f1 98%);
		border-radius: 8px;
	}

	.Recharge .content .title {
		border: none;
		font-size: 20px;
		font-family: PingFang SC, PingFang SC-Semibold;
		font-weight: Semibold;
		color: #4b2e1c;
	}

	.Recharge .content .tab {
		margin-top: 18px;
		padding: 0 15px;
		gap: 8px;
		display: flex;
	}

	.Recharge .content .tab .item {
		display: flex;
		flex: 1;
		flex-direction: column;
		align-items: center;
		background: #ffffff;
		border: 1px solid #f9b762;
		border-radius: 8px;
		cursor: pointer;
	}

	.Recharge .content .tab .item.active {
		background: linear-gradient(180deg, #fff1de, #ffdeba);
	}

	.Recharge .content .tab .item.active .text {
		background: #FF7C5E;
		color: #fff;
		border-top: 1px solid #FF7C5E;
	}

	.Recharge .content .tab .item .number {
		font-size: 16px;
		font-weight: bold;
		color: rgba(172, 124, 94, 0.98);
		margin-top: 12px;
	}

	.Recharge .content .tab .item .money {
		font-size: 20px;
		font-weight: bold;
		color: #4b2e1c;
		margin-top: 6px;
	}

	.Recharge .content .tab .item .originalPrice {
		font-size: 10px;
		color: rgba(172, 124, 94, 0.65);
		margin-top: 4px;
		text-decoration: line-through;
	}

	.Recharge .content .tab .item .text {
		width: 100%;
		font-size: 10px;
		color: #4b2e1c;
		margin-top: 12px;
		background: #ffedd6;
		border-top: 1px solid #facb8d;
		border-radius: 0px 0px 7px 7px;
		text-align: center;
		padding: 7px 0;
	}

	.Recharge .content .button {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 199px;
		height: 39px;
		background: #ff7c5e;
		border-radius: 5px;
		font-size: 15px;
		font-family: PingFang SC, PingFang SC-Medium;
		font-weight: Medium;
		color: #ffffff;
		margin: 20px auto;
		cursor: pointer;
	}

	.emailPrompt .content {
		height: auto;
	}

	.emailPrompt .content .text {
		padding: 40px 20px;
		font-size: 16px;
		color: #333333;
	}

	.emailPrompt .content .text span {
		color: #1877FF;
		font-weight: bold;
		cursor: pointer;
	}

	.emailPrompt .content .balancePopup .text {
		text-align: center;
		font-size: 16px;
		font-weight: bold;
		color: #f73b42;
	}

	.emailPrompt .content .button {
		display: flex;
		align-items: center;
	}

	.emailPrompt .content .button .item {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 50%;
		height: 46px;
		left: 0;
		bottom: 0;
		border-top: 1px solid #E4E4E4;
		font-size: 17px;
		font-weight: 600;
		color: #3A60FF;
		cursor: pointer;
	}

	.emailPrompt .content .button .item+.item {
		border-top: 1px solid #E4E4E4;
		background: #3A60FF;
		color: #ffffff;
		border-radius: 0 0 8px 0;
	}

	.emailPolicy .content {
		width: 800px;
		min-height: 60vh;
		max-height: 80vh;
		overflow-x: hidden;
	}

	.emailPolicy .content .text {
		width: 100%;
		padding: 20px;
		font-size: 15px;
		color: #3c4252;
		text-indent: 2em;
		line-height: 1.4;
	}

	.emailRecord .table-header {
		display: flex;
		background: #f6f7fa;
		border-bottom: 1px solid #f1f3f8;
		font-weight: bold;
		padding: 0 10px;
		width: 100%;
		height: 43px;
	}

	.emailRecord .table-row {
		display: flex;
		border-bottom: 1px solid #f1f3f8;
		padding: 0 10px;
		height: 50px;
		align-items: center;
	}

	.emailRecord .col:first-child {
		justify-content: flex-start;
		padding-left: 30px;
	}

	.emailRecord .col {
		flex: 1;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.emailRecord .col-email {
		flex: 1.5;
		text-align: left;
	}

	.emailRecord .col-name {
		flex: 1;
	}

	.emailRecord .col-status {
		flex: 1;
	}

	.emailRecord .col-action {
		flex: 1;
	}

	.emailRecord .success {
		color: #67c23a;
	}

	.emailRecord .fail {
		color: #f56c6c;
	}

	.emailRecord .resend {
		color: #1877ff;
		cursor: pointer;
		text-align: center;
	}
</style>


// WEBPACK FOOTER //
// src/views/MyPage/index.vue